import cn from "classnames";
import { Transition } from "components/shared/column";
import { Checkbox, Datetime, Field, FileField, Flags, Select } from "components/shared/form";
import Loader from "components/shared/loader";
import { renderRelatedFields, serializeReq, validateForm } from "helpers/form";
import React, { Component } from "react";

export default class BookForm extends Component {
    state = {
        isLoading: true,
        isValid: true,
    };

    componentDidMount() {
        this.setState({ isLoading: false, ...this.props.initialState });
    }

    close = () => {
        const { mergeParams, back, modalProps } = this.props;
        if (mergeParams) {
            mergeParams({});
        }
        back?.();
        modalProps?.close();
    };

    isValidForm = (state) => {
        const { config } = this.props;
        return validateForm(config, serializeReq(state));
    };

    setValue = ({ name, value }) => {
        const isValid = this.isValidForm({ ...this.state, [name]: value });
        this.setState({ [name]: value, ...(isValid ? { isValid: true } : {}) });
    };

    applyReq = (serialized) => {
        return this.props
            .submit(serialized)
            .then((res) => (res ? this.close() : this.setState({ isLoading: false, isValid: false })));
    };

    onSubmit = (e) => {
        e.preventDefault();
        const { isLoading, isValid, ...state } = this.state;
        if (!isLoading) {
            if (this.isValidForm(state)) {
                this.setState({ isLoading: true, isValid: true });
                return this.applyReq(serializeReq(state));
            }
            this.setState({ isValid: false });
        }
    };

    value = (inputName) => this.state[inputName];

    renderField = (props) => {
        if (!props || !props.inputProps) {
            return null;
        }
        return (
            <Field key={props.label} onChange={this.setValue} value={this.value(props.inputProps.name)} {...props} />
        );
    };

    renderFileField = (props) => {
        if (!props || !props.inputProps) {
            return null;
        }
        return (
            <FileField
                key={props.label}
                onChange={this.setValue}
                value={this.value(props.inputProps.name)}
                {...props}
            />
        );
    };

    renderDateField = (props) => {
        if (!props || !props.inputProps) {
            return null;
        }
        return (
            <Datetime key={props.label} onChange={this.setValue} value={this.value(props.inputProps.name)} {...props} />
        );
    };

    renderSelect = (props) => {
        if (!props || !props.inputProps) {
            return null;
        }
        const defProps = {
            key: props.label,
            wrapper: "book-field",
            onChange: this.setValue,
            value: this.value(props.inputProps.name),
        };
        props.dictionary && (props.options = this.props.enums[props.dictionary] || []);
        if (props.relatedFields) {
            const fieldsData = { defProps, props, renderSelect: this.renderSelect, renderField: this.renderField };
            return renderRelatedFields(fieldsData);
        }
        const { key, ...selectProps } = { ...defProps, ...props };
        return <Select {...selectProps} key={key} />;
    };

    renderCheckbox = (props) => {
        if (!props || !props.inputProps) {
            return null;
        }
        return (
            <Checkbox key={props.label} onChange={this.setValue} value={this.value(props.inputProps.name)} {...props} />
        );
    };

    renderFlags = (props) => {
        if (!props || !props.inputProps) {
            return null;
        }
        return (
            <Flags key={props.label} {...props} onChange={this.setValue} value={this.value(props.inputProps.name)} />
        );
    };

    renderBody = () => {
        return null;
    };

    renderFooter = () => {
        return (
            <div className="book-form__actions">
                <input type="submit" className="btn btn-brand btn-sm" value="Создать" />
            </div>
        );
    };

    renderHead = () => {
        return (
            <div className="book-form__head">
                <div className="book-form__title">{this.props.title}</div>
                <div className="book-form__close close close--sm" onClick={this.close} />
            </div>
        );
    };

    render() {
        const { isValid, isLoading } = this.state;
        const cname = cn("book-form__body", { "book-form__body--invalid": !isValid });
        return (
            <Transition dir="full">
                {isLoading ? (
                    <div>
                        <Loader prefix="absolute-center" />
                    </div>
                ) : (
                    <div>
                        {this.renderHead()}
                        <form className={cname} onSubmit={this.onSubmit}>
                            <div className="overflow-auto h-100 w-100">
                                <div className="content-wrapper">{this.renderBody()}</div>
                            </div>
                            {this.renderFooter()}
                        </form>
                    </div>
                )}
            </Transition>
        );
    }
}
